import { Carousel, Col } from "react-bootstrap";

function HomeCarousel() {
  return <>
    <Carousel controls={false} indicators={false} className="d-none d-sm-none d-md-block">
      <Carousel.Item>
        <div className="carousel-image" style={{
          backgroundImage: 'url(/home/home-1.jpg)'
          }}></div>
        {/* <img src="/home/home-1.jpg" /> */}
        <Carousel.Caption>
            <h5>Quiénes somos</h5>
            <p>Somos una organización católica de laicos, asistidos por asesores espirituales, que fomenta la espiritualidad conyugal y el apostolado familiar, inspirada por los valores del evangelio.</p>
          </Carousel.Caption>
      </Carousel.Item>
    </Carousel>
    <div className="d-block d-md-none mision somos">
      <div>
        <div className="image" style={{
            backgroundImage: 'url(/home/home-1.jpg)'
          }}></div>
        <Col>
          <h5>Quiénes somos</h5>
          <p>Somos una organización católica de laicos, asistidos por asesores espirituales, que fomenta la espiritualidad conyugal y el apostolado familiar, inspirada por los valores del evangelio.</p>
        </Col>
      </div>
    </div>
  </>;
}

export default HomeCarousel;